(ns practitest.frontend.impersonation
  (:require
   [practitest.frontend.common.i18n :refer [format-translation get-translation]]
   [practitest.frontend.common.mixpanel :as mixpanel]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components.modal :as modal]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.subs :as subs]
   [re-frame.core :as re-frame]))

(re-frame/reg-event-db
  ::show
  (fn [db [_ config]]
    (assoc db :impersonation-modal config)))

(re-frame/reg-event-db
  ::hide
  (fn [db _]
    (dissoc db :impersonation-modal)))

(re-frame/reg-sub
  ::modal-config
  (fn [db _]
    (:impersonation-modal db)))

(defn impersonation-modal []
  (let [config       @(re-frame/subscribe [::modal-config])
        {:keys [integration-name authorize-url]} config
        user-id      (:id @(re-frame/subscribe [::subs/current-user]))
        personal-url (str (broutes/get-url "users#edit" {:id user-id}) "?return_to=%2Fpersonals")
        hide!        #(re-frame/dispatch [::hide])]
    [modal/bootstrap-modal
     {:is-open?         (boolean config)
      :on-request-close hide!
      :class            "impersonation-modal"
      :close-button?    true
      :centered?        true
      :title-class      "justify-content-center"
      :footer-class     "justify-content-center"}

     ;; header
     [:div.impersonation-title
      [:span.impersonation-warning-icon [icons/exclamation-circle-fill]]
      (format-translation
        (get-translation "impersonation.title" "Link your %{integration} User")
        {:integration integration-name})]

     ;; body
     [:div.impersonation-body
      [:p
       (format-translation
         (get-translation "impersonation.no-user-linked" "No %{integration} user is linked.")
         {:integration integration-name})
       [:br]
       (format-translation
         (get-translation "impersonation.please-link" "Please link your %{integration} user to perform actions in %{integration}.")
         {:integration integration-name})]
      [:p
       (get-translation "impersonation.one-time-setup" "This is a one-time setup and can also be configured later in ")
       [:a {:href personal-url :target "_blank"}
        (get-translation "impersonation.personal-settings" "Personal Settings")]
       "."]]

     ;; footer
     [:div.impersonation-actions
      [buttons/button {:on-click hide!
                       :text     (get-translation "generic.button.cancel" "Cancel")
                       :size     "large"}]
      [buttons/button {:primary? true
                       :on-click #(do (mixpanel/track "Impersonation Activated - PopUp Settings"
                                                      {"integrated_system" integration-name})
                                      (js/window.open authorize-url "_blank"))
                       :text     (get-translation "impersonation.link-user" "Link User")
                       :size     "large"}]]]))

(defn ^:export show [js-config]
  (re-frame/dispatch [::show (js->clj js-config :keywordize-keys true)]))
